var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoryblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_90898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z",
    fill: "#F0F2F6",
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.595 8.9082C11.0556 8.9082 10.624 9.33982 10.624 9.85775V26.8201C10.624 27.338 11.0556 27.6617 11.5734 27.6617H14.0763V31.0499L17.1833 27.6833H28.5326C29.0504 27.6833 29.374 27.3596 29.374 26.8201V9.87933C29.374 9.3614 29.072 8.9082 28.5326 8.9082H11.595Z",
    fill: "#00B3B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7682 12.2969C23.1994 12.2969 23.5661 12.3831 23.911 12.5772C24.2345 12.7498 24.5364 12.987 24.7736 13.2674C25.2567 13.8566 25.5163 14.5974 25.5068 15.3593C25.5068 15.9201 25.3558 16.4592 25.0754 16.9768C24.7849 17.4975 24.3299 17.907 23.7817 18.1414C24.4717 18.3355 25.0108 18.6806 25.4205 19.1766C25.8087 19.6942 26.0028 20.3628 26.0028 21.2039C26.0028 21.7431 25.9044 22.2234 25.7009 22.5841C25.4852 22.9724 25.1617 23.2958 24.7736 23.533C24.3638 23.7918 23.911 24.0291 23.3935 24.1369C22.876 24.2664 22.3153 24.3742 21.7332 24.3742H14.0996V12.2969H22.7682ZM21.5297 19.0467H17.208V21.0869H21.4258C21.6752 21.0869 21.9037 20.9849 22.0907 20.8216C22.257 20.6585 22.3609 20.4136 22.3609 20.1076C22.3668 19.8451 22.2868 19.5876 22.1323 19.3731C21.9661 19.1692 21.7791 19.0467 21.5297 19.0467ZM21.1766 14.9665H17.208V16.8026H21.0934C21.3012 16.8026 21.5089 16.7006 21.6752 16.5782C21.8622 16.4558 21.9453 16.1906 21.9453 15.8438C21.9453 15.5378 21.8622 15.3134 21.7167 15.1706C21.5713 15.0481 21.3843 14.9665 21.1766 14.9665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_90898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryblock);
export default __webpack_public_path__ + "static/media/Storyblock.f8e4beb13379526954b8ce7fba7b9713.svg";
export { ForwardRef as ReactComponent };